var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-layout',[_c('v-flex',[_c('login')],1),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.$vuetify.breakpoint.xl || _vm.$vuetify.breakpoint.lg),expression:"$vuetify.breakpoint.xl || $vuetify.breakpoint.lg"}]},[_c('SideImage')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }